import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MenuModule } from './share/menu/menu.module';
import { ApiInterceptor } from './interceptor/api/api-interceptor';
import { CommonModule } from '@angular/common';
import { ShiftModule } from './modal/shift/shift.module';
import { GalleryModule } from './share/gallery/gallery.module';
import { MessagesModalModule } from './modal/messages-modal/messages-modal.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from './helper/http-loader-factory/http-loader-factory'
import { Language } from './enum/language';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToastModule } from './share/toast/toast.module';
import { initializeApp, getApps } from 'firebase/app';

// @ts-ignore
window.io = require('socket.io-client');

if (!getApps().length) {
	initializeApp({
		apiKey: 'AIzaSyBXiXiGZNqSQsrBKsIN74DyXhIt0IaVza8',
		authDomain: 'yeti-software---fresh-start-20.firebaseapp.com',
		projectId: 'yeti-software---fresh-start-20',
		storageBucket: 'yeti-software---fresh-start-20.firebasestorage.app',
		messagingSenderId: '793824503515',
		appId: '1:793824503515:ios:dd248cf15f3e8d15a1cefe',
	});
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		CommonModule,
		BrowserModule,
		IonicModule.forRoot(),
		AppRoutingModule,
		HttpClientModule,
		MenuModule,
		ShiftModule,
		GalleryModule,
		MessagesModalModule,
		FlexLayoutModule,
		NgxMaskDirective,
		NgxMaskPipe,
		ToastModule,
		TranslateModule.forRoot({
			defaultLanguage: Language.ENGLISH,
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
	],
	providers: [
		{
			provide: RouteReuseStrategy,
			useClass: IonicRouteStrategy
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ApiInterceptor,
			multi: true,
		},
		Network,
		provideNgxMask()
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
